import React from 'react'
import puckpediaLogo from './puckpedia.svg'

import './Puckpedia.scss'

const Puckpedia = ({ link }) => {
    return (
        <div className="Puckpedia__cont">
            <div className="pedia_cont">
                <span>Salary info provided by</span>
                <a href={link} className="puckpedia_btn">
                    <img className="logo" src={puckpediaLogo} alt="puckpedia" />
                </a>
            </div>
            <div className="number_glossary">
                <span
                    href="http://www.sportsnet.ca/hockey/nhl/fanager-glossary/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Glossary of Salary Terms
                </span>
            </div>
        </div>
    )
}

export default Puckpedia
